import { useState } from "react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";
import { submitForm } from "../../../api/submitForm";
import Honeypot from "../../../components/honeypot";
import { useFormTiming } from "../../../components/useFormTiming";

const INTERESTS = [
  "Device Marketplace",
  "Procurement & Deployment",
  "Ongoing Management (MDM)",
  "Maintenance & Repair",
  "End of Life / Disposal",
  "Not sure yet",
];

const GetAQuote = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.getAQuote");
  const [form, setForm] = useState({ name: "", company: "", email: "", interest: "", quantity: "", details: "" });
  const [hp, setHp] = useState("");
  const startedAt = useFormTiming();
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [error, setError] = useState("");

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    const result = await submitForm(
      "quote",
      "deviceworks",
      {
        name: form.name,
        company: form.company,
        email: form.email,
        interest: form.interest,
        quantity: form.quantity,
        details: form.details,
      },
      { hp, startedAt }
    );
    if (result.ok) {
      setStatus("sent");
    } else {
      setStatus("error");
      setError(result.error);
    }
  };

  return (
    <div>
      <PageHeader eyebrow={h.eyebrow} title={h.title} description={h.description} />
      <div className="max-w-md mx-auto px-5 py-16">
        {status === "sent" ? (
          <p className="dw-mini text-center">Thanks — your request has been received. Our team will follow up shortly.</p>
        ) : (
          <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
            <Honeypot value={hp} onChange={(e) => setHp(e.target.value)} />
            <input className="dw-field" placeholder="Name" required value={form.name} onChange={update("name")} />
            <input className="dw-field" placeholder="Company" required value={form.company} onChange={update("company")} />
            <input type="email" className="dw-field" placeholder="Email" required value={form.email} onChange={update("email")} />
            <select className="dw-field" required value={form.interest} onChange={update("interest")}>
              <option value="" disabled>Interest area</option>
              {INTERESTS.map((i) => <option key={i} value={i}>{i}</option>)}
            </select>
            <input className="dw-field" placeholder="Approximate quantity (optional)" value={form.quantity} onChange={update("quantity")} />
            <textarea className="dw-field" placeholder="Details" rows="4" required value={form.details} onChange={update("details")} />
            <button type="submit" className="dw-btn self-start mt-1" disabled={status === "sending"}>
              {status === "sending" ? "Submitting…" : "Submit"}
            </button>
            {status === "error" && <p className="dw-mini" style={{ color: "#e06666" }}>{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
};

export default GetAQuote;
